var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CurrentUser',{scopedSlots:_vm._u([{key:"default",fn:function({ user }){return [(user.id)?_c('InvocationsList',{attrs:{"user-id":user.id}}):_vm._e()]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }